import React, { useState } from 'react'
import '../../style/prepare.css'
import TabArea from './TabArea'
import CameraArea from './CameraArea'
import Footer from './Footer'

const PrepareView = () => {
    const [camera, SetCamera] = useState(true)
    const [microphone, SetMicrophone] = useState(true)

    return (
        <div>
            <TabArea />
            <CameraArea camera={camera} microphone={microphone} />
            <Footer
                setCamera={SetCamera}
                isOpenCamera={camera}
                setMicrophone={SetMicrophone}
                isOpenMicrophone={microphone}
            />
        </div>
    )
}

export default PrepareView